import { Helmet } from 'react-helmet-async';

const DOMAIN = 'https://rteqsolutions.com';
const LOGO = 'https://customer-assets.emergentagent.com/job_preview-suite/artifacts/bkqjgsqq_RteQ_Solutions_Logo-removebg-preview.png';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${DOMAIN}/#localbusiness`,
  name: 'RTEQ Solutions',
  alternateName: 'RTEQ',
  description: 'Professional ECU tuning, automotive diagnostics, and vehicle software management platform. Over 100 specialized services for cars, bikes, trucks, marine, and agriculture vehicles.',
  url: DOMAIN,
  logo: LOGO,
  image: LOGO,
  telephone: '+35799580396',
  email: 'Info@rteqsolutions.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Galilaiou 11, Agios Ioannis',
    addressLocality: 'Limassol',
    postalCode: '3015',
    addressCountry: 'CY',
    addressRegion: 'Limassol',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 34.6823,
    longitude: 33.0464,
  },
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '07:30',
    closes: '17:00',
  },
  priceRange: '$$',
  areaServed: [
    { '@type': 'Country', name: 'Cyprus' },
    { '@type': 'Country', name: 'Greece' },
    { '@type': 'Place', name: 'Worldwide' },
  ],
  serviceType: [
    'ECU Chip Tuning',
    'Stage 1 Tuning',
    'Stage 2 Tuning',
    'Stage 3 Tuning',
    'DPF Solutions',
    'EGR Solutions',
    'AdBlue Solutions',
    'Remote Automotive Diagnostics',
    'ECU Remapping',
    'Custom Tuning',
    'Automotive Software',
  ],
  knowsAbout: [
    'ECU Tuning',
    'Chip Tuning',
    'Automotive Diagnostics',
    'WinOLS',
    'Flash Tool',
    'ECU Remapping',
    'Vehicle Software',
    'Remote Diagnostics',
  ],
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${DOMAIN}/#organization`,
  name: 'RTEQ Solutions',
  url: DOMAIN,
  logo: {
    '@type': 'ImageObject',
    url: LOGO,
  },
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+35799580396',
      contactType: 'customer service',
      areaServed: 'CY',
      availableLanguage: ['English', 'Greek'],
    },
    {
      '@type': 'ContactPoint',
      telephone: '+306951976619',
      contactType: 'customer service',
      areaServed: 'GR',
      availableLanguage: ['English', 'Greek'],
    },
  ],
  numberOfEmployees: {
    '@type': 'QuantitativeValue',
    minValue: 4,
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${DOMAIN}/#website`,
  name: 'RTEQ Solutions',
  url: DOMAIN,
  inLanguage: ['en', 'el'],
  publisher: { '@id': `${DOMAIN}/#organization` },
};

const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `${DOMAIN}${item.path}`,
  })),
});

const serviceSchemasEN = [
  { name: 'ECU Chip Tuning', description: 'Professional ECU tuning services including Stage 1, Stage 2, and Stage 3 for all vehicle types.' },
  { name: 'Remote Automotive Diagnostics', description: 'Live troubleshooting, fault analysis, and ECU support via remote diagnostic tools.' },
  { name: 'Automotive Software & Tools', description: 'Integrated flash tools, file database access, and advanced automotive software solutions.' },
  { name: 'DPF Solutions', description: 'Professional diesel particulate filter solutions for improved vehicle performance.' },
  { name: 'EGR Solutions', description: 'Exhaust gas recirculation optimization for diesel engines.' },
];

const serviceSchemas = serviceSchemasEN.map((s) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: s.name,
  description: s.description,
  provider: { '@id': `${DOMAIN}/#localbusiness` },
  areaServed: { '@type': 'Place', name: 'Worldwide' },
}));

const StructuredData = ({ path }) => {
  const schemas = [localBusinessSchema, organizationSchema, websiteSchema];

  if (path === '/') {
    schemas.push(breadcrumbSchema([{ name: 'Home', path: '' }]));
  } else if (path === '/suite') {
    schemas.push(breadcrumbSchema([{ name: 'Home', path: '' }, { name: 'Portal', path: '/suite' }]));
  } else if (path === '/services') {
    schemas.push(breadcrumbSchema([{ name: 'Home', path: '' }, { name: 'Services', path: '/services' }]));
    schemas.push(...serviceSchemas);
  } else if (path === '/company') {
    schemas.push(breadcrumbSchema([{ name: 'Home', path: '' }, { name: 'Company', path: '/company' }]));
  } else if (path === '/contact') {
    schemas.push(breadcrumbSchema([{ name: 'Home', path: '' }, { name: 'Contact', path: '/contact' }]));
  }

  return (
    <Helmet>
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default StructuredData;
